import {ecSendData, trackEvent, sendFacebookConversionsEvent} from "../../library/analytics";
import {popupInfoDialog} from "../../library/info-dialog";
import {addToCartAjax} from "./add-to-cart-personalized";
import {sendFloodLightEvent, showShoppingCart} from "./product-shopping-cart";
import {uploadImage, uploadImageBase64} from "./upload-image";
import {getPriceFormat} from "./price-format";
import {configureHelpWidget} from "./help-widget";

let imageWidth,
    imageHeigth,
    console,
    $image,
    URL,
    fitDimensions,
    dataWidth,
    dataHeight,
    userWidth = $('#width'),
    userHeight = $('#height'),
    maxWidth = 555,
    maxHeight = 555;

$(document).ready(function () {
    $('#uploadedDesignPath').val('');
    $(document).on("change", ".qty-display, input[name='quantity']:checked", function() {
        trackEvent('PortraitSticker', 'ModifyQuantity', $('.qty-display').val());
    });

    $('.pers-size-block').on('keypress', '.input-box', function(event){
        if ((event.which != 8 && event.which != 46 && event.which != 44 && isNaN(String.fromCharCode(event.which))) || event.which == 32) {
            event.preventDefault();
            return false;
        }
    });

    $(document).on("change", "#width, #height", function() {
        let w = $('#width'),
            h = $('#height'),
            alert = $('#wrongSizeAlert'),
            widthMin = Number(w.attr('data-min')),
            heigthMin = Number(h.attr('data-min'));
        alert.slideUp('fast');
        if (w.val() < widthMin || h.val() < heigthMin) {
            alert.slideDown('fast');
        } else {
            if($image) $image.cropper('destroy');
            checkInputsAndImageAndExecuteCropper();
        }
    });

    $('.btnShowInfo').click(function() {
        $(this).parent().removeClass('visible-xs');
    });

    doAfterFirstColorSelect();
    $('.contentColorSelect').click(function(){
        trackEvent('PortraitSticker', 'Color', $(this).children().attr('title'));
        let id = $(this).attr('id');
        let idArray = id.split("-");
        id = idArray[1];
        $('#color').val(id);
        $('#colorNameButton').html($(this).children().attr('title'));
        $('.divColorBackground').css('background-color', $(this).children().css('background-color'));
        updatePrice();
    });

    $('#color').val(0);

    $('#upload-file').on('change', function(event) {
        let files = event.target.files;

        uploadImage(
            files,
            {
                prefix: 'portrait',
                onlyPrintable: true
            },
            function(data) {
                $('#uploadedDesignPath').val(data.fileInfo.file);
                $('#uploadedDesignWidth').val(data.fileInfo.width);
                $('#uploadedDesignHeight').val(data.fileInfo.height);
                $('#uploaded-image').attr('src', '/' + data.fileInfo.file).load(function() {
                    $('.upload-block').fadeOut('fast', function() {
                        $('.preview-block').fadeIn('fast');
                    });
                    imageWidth = data.fileInfo.width;
                    imageHeigth = data.fileInfo.height;
                    checkInputsAndImageAndExecuteCropper(imageWidth,imageHeigth);
                });
                $('#btnReplaceDesign').fadeIn('fast');
                trackEvent('PortraitSticker', 'Upload', 'ok');
            },
            function(data) {
                replaceDesign();
                popupInfoDialog(data.error);
                trackEvent('PortraitSticker', 'Upload', 'error');
            }
        );
    });

    $('#btnReplaceDesign').click(function(){
        replaceDesign();
    });

    $(document).on("click", ".btn-add-to-cart", function() {
        addToCart();
    });
    $(document).on("change", ".qty-display, input[name='quantity']", function() {
        onQuantityChange();
    });

    $('.button-show-info').click(function (e) {
        let type = $(this).data('type');

        showInfoDialog(type);
    });

    $(window).resize(function(){
        if ($('this').width < 768) {
            maxWidth = 330;
            maxHeight =  330;
            fitDimensions = calculateAspectRatioFit(width,height,maxWidth,maxHeight);
        }
    });

    //$('.btn-add-to-cart').attr('disabled', 'disabled');

    $(document).on('change', 'input[name="complement"], input[class="cross-selling-select-product"]', function () {
        if ($(this).is(':checked') && ($(this).data('name') || $(this).data('reference'))) {
            trackEvent('PortraitSticker', 'Complement', $(this).data('name') || $(this).data('reference'));
        }
    });

    $(document).on('click', '.quantity-selector li', function() {
        let container = $(this).closest('.quantity-selector');
        let preview = container.find('.quantity-preview');
        let input = $(this).find('input');
        let quantity = input.val();

        container.find('li').removeClass('selected');
        $(this).addClass('selected');
        input.prop('checked', true);
        input.change();
        preview.text(quantity);
    });

    configureHelpWidget();
});

function checkInputsAndImageAndExecuteCropper(imageWidth,imageHeigth) {
    if (!$('#width').val()  || !$('#height').val()) {
        return;
    }
    if ($('#uploadedDesignPath').val() !== '') {
        $('.btn-add-to-cart').removeAttr('disabled');
        initCropper(imageWidth, imageHeigth);
        trackEvent('PortraitSticker', 'initCropper', 'ok');
    }
    updatePrice(true);
}

function doAfterFirstColorSelect() {
    $("#color").val(67);
}
function replaceDesign() {
    if ($image) {
        $image.cropper('destroy');
    }

    resetInput($('#upload-file'));
    $('#uploadedDesignPath').val('');
    $('#uploadedDesignWidth').val('');
    $('#uploadedDesignHeight').val('');

    if ($('.preview-block').is(':visible')) {
        trackEvent('PortraitSticker', 'replaceDesign', 'Replace Again');
        $('.preview-block').fadeOut('fast', function() {
            $('.upload-block').fadeIn('fast');
        });
    } else {
        $('.no-preview-block').fadeOut('fast', function() {
            $('.upload-block').fadeIn('fast');
        });
    }
    $('#btnReplaceDesign').fadeOut('fast');

}
function resetInput(input){
    input.wrap('<form>').parent('form').trigger('reset');
    input.unwrap();
}

function resetUserScreenVal() {
    $('#width').val('') ;
    $('#height').val('');
}

function resetColor() {
    $('#color').val(0);
    $('#colorNameButton').html('');
    $('.divColorBackground').css('background-color', '');
}

function showInfoDialog(type){
    $.post(
        '/ajax/service/info-dialog',
        {type: type},
        function(data){
            popupInfoDialog(data.content);
        },
        'json'
    );
}

var updateAJAX;
function updatePrice(forceUpdateQuantitySelector = false) {
    if (typeof updateAJAX == 'object') {
        updateAJAX.abort();
    }

    if (forceUpdateQuantitySelector) $('input[name="quantity"][value="1"]').prop('checked', true);

    let width = $('#width').val();
    let height = $('#height').val();
    let color = $('#color').val();
    let quantity = parseInt($('input[name="quantity"]:checked').val());

    window.console.log(quantity);

    if (!isNaN(width) && width > 0 && !isNaN(height) && height > 0) {
        $('.btn-add-to-cart').attr('disabled', 'disabled');
        $.post(
            '/ajax/service/portrait-sticker-update-price',
            {
                width: width,
                height: height,
                units: quantity,
                color: color,
                productType: 'Retrato'
            },
            function (data) {
                if (forceUpdateQuantitySelector) updateQuantitySelector(data.price);
                let price = parseFloat(data.price) * quantity;

                $('.btn-item-price').text(getPriceFormat(price.toFixed(2)));
                $('.btn-add-to-cart').removeAttr('disabled');
            },
            'json'
        ).fail(function () {
            $('.btn-add-to-cart').removeAttr('disabled');
        });
    } else {
        $('.btn-item-price').text(0);
    }
}

function addToCart() {
    let width = $('#width').val();
    let height = $('#height').val();
    let price = $('.btn-item-price').text();

    //validacio inputs
    if ((isNaN(width) && width <= 0) ||
        (isNaN(height) && height <= 0) || !$image || price === 0) {
        return;
    }
    let canvas = $image.cropper('getCroppedCanvas');
    let imgBase64 = canvas.toDataURL("image/png", 1);
    uploadImageBase64(
        imgBase64,
        {prefix: 'portrait'},
        function(data) {
            $('#uploadedDesignPath').val(data.file);
            addToCartWithCroppedImage();
        }
    );
}

function onQuantityChange() {
    updatePrice();
}
function addToCartWithCroppedImage() {
    let productId = $('#productId').val();
    let width = $('#width').val();
    let height = $('#height').val();
    let color = $('#color').val();
    let file = $('#uploadedDesignPath').val();
    let needPreview = $('#needPreview').val();
    let preview = $('#preview-image').html();
    let units = $('input[name="quantity"]:checked').val();
    if (units < 1) {
        units = 1;
    }
    let complements = [];
    $('input[name="complement"]:checked').each(function() {
        let complement = $(this);
        complements.push(
            {
                'id': complement.data('id'),
                'locked': complement.data('locked'),
                'linkToParent': complement.data('link-to-parent'),
                'options': {'size': complement.data('size-id')}
            }
        );
    });

    let crossSellingProducts = [];
    $('.cross-selling-select-product:checked').each(function() {
        let product = $(this);
        let options = {
            'size': product.data('size-id'),
            'originalProduct': $('#productId').val(),
            'personalizedImage': product.data('image'),
            'color': product.data('color'),
        };
        if (product.data('material-color')) {
            options['materialColor'] = product.data('material-color');
        }
        if (product.data('model')) {
            options['model'] = product.data('model');
        }
        if (product.data('pack')) {
            options['pack'] = product.data('pack');
        }
        crossSellingProducts.push(
            {
                'id': product.data('id'),
                'options': options,
                'locked': product.data('locked'),
                'linkToParent': product.data('link-to-parent')
            }
        );
    });
    let referrer = null;
    if (document.referrer.indexOf(location.protocol + "//" + location.host) === 0) referrer = document.referrer;


    addToCartAjax(
        {
            productId: productId,
            quantity: units,
            needPreview: needPreview,
            preview: preview,
            options: {
                width: width,
                height: height,
                color: color,
                personalizedImage: file,
                quantity: units,
                orientation: 'normal',
                reversed: false,
                referrer: referrer,
            },
            isLocked: true,
            complements,
            crossSellingProducts
        },
        function(data){successAddToCart(data)},
        function(data){failureAddToCart(data)}
    );
}

function successAddToCart(data)
{
    // Reset size for unbroke images
    $('#width').val('');
    $('#height').val('');

    if (data.cartItems) {
        $.each(data.cartItems, function (index, item) {
            if (item) {
                ecSendData(item.reference, item.name, item.unitPrice, item.quantity, item.colorApaCode, item.size, 'normal', 'add', null);
                trackEvent('PortraitSticker', 'AddToCart', $('h1').text());
                if (window.fbq) {
                    var payload = {
                        content_type: 'product',
                        content_name: item.name,
                        content_ids: [item.reference],
                        contents: [
                            {
                                id: item.reference,
                                quantity: item.quantity,
                                price: item.unitPrice
                            }
                        ]
                    };
                    sendFacebookConversionsEvent('AddToCart', payload);
                }
                if (window.pintrk) {
                    pintrk('track', 'AddToCart', {
                        value: item.unitPrice,
                        order_quantity: item.quantity,
                        currency: item.currency
                    });
                }
            }
        });
    }
    sendFloodLightEvent();
    replaceDesign();
    resetInput($('#upload-file'));
    resetUserScreenVal();
    resetColor();
    showShoppingCart();
    $('.btn-item-price').text(0);
    $('input[name="complement"]').prop("checked", false);
}

function failureAddToCart(data)
{
    trackEvent('PortraitSticker', 'AddToCart', 'error');
    if (data.errorCode == 'color') {
        $('html, body').animate({ scrollTop: $('#buttonColor').offset().top - 150 }, 'slow');
    }
    let errorMessage = data.errorMessage;
    if (typeof errorMessage !== 'string') {
        errorMessage = 'Error';
    }
    popupInfoDialog(errorMessage);
}

function initCropper(width, height) {
    'use strict';

    console = window.console || { log: function () {} };
    URL = window.URL || window.webkitURL;
    $image = $('#uploaded-image');
    fitDimensions = calculateAspectRatioFit(width,height,maxWidth,maxHeight);
    let options = {
        //Image proportions done by user
        aspectRatio: computeAspectRatio(userWidth.val(),userHeight.val()),
        autoCropArea: 0,
        //preview: '.img-preview',
        crop: function (e) {
            dataHeight = Math.round(e.height);
            dataWidth = Math.round(e.width);
        },
        //Dimensions del container
        minContainerWidth: fitDimensions.width,
        minContainerHeight:fitDimensions.height
    };
    let originalImageURL = $image.attr('src');
    // Cropper
    $image.on({
        ready: function (e) {
            console.log(e.type);
        },
        cropstart: function (e) {
            console.log(e.type, e.action);
        },
        cropmove: function (e) {
            console.log(e.type, e.action);
        },
        cropend: function (e) {
            console.log(e.type, e.action);
        },
        crop: function (e) {
            console.log(e.type, e.x, e.y, e.width, e.height, e.rotate, e.scaleX, e.scaleY);
        },
        zoom: function (e) {
            console.log(e.type, e.ratio);
        }
    }).cropper(options);

}
function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    /*
    * srcWidth and srcHeight -> image size
    * maxWidth and maxHeight -> limited size
    * */
    let ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth*ratio, height: srcHeight*ratio };
}

function computeAspectRatio(w, h){
    return w/h;
}

function updateQuantitySelector(price)
{
    $.post(
        '/ajax/personalized-services/get-quantity-selector',
        {
            productId: $("#productId").val(),
            price: price
        },
        function(data){
            if (data.quantitySelector && data.quantitySelector.length) {
                $('.add-to-cart-quantity-selector').html(data.quantitySelector);
            }
        }
    );
}